
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/feature-flags",
      function () {
        return require("private-next-pages/tools/feature-flags/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/feature-flags"])
      });
    }
  